"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var NumberCountComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(NumberCountComponent, _Mixins);

  var _super = _createSuper(NumberCountComponent);

  function NumberCountComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, NumberCountComponent);
    _this = _super.apply(this, arguments);
    _this.displayNumber = 0;
    _this.interval = false;
    return _this;
  }

  (0, _createClass2.default)(NumberCountComponent, [{
    key: "numberCountStyles",
    get: function get() {
      var fontSize = this.$props.fontSize;

      if (this.$props.number > 1000000) {
        fontSize = '2rem';
      }

      return {
        'font-size': fontSize
      };
    }
  }, {
    key: "created",
    value: function created() {
      var _this2 = this;

      clearInterval(this.interval);
      this.interval = window.setInterval(function () {
        var change = (Number(_this2.$props.number) - _this2.displayNumber) / 10;
        change = change >= 0 ? Math.ceil(change) : Math.floor(change);
        _this2.displayNumber = _this2.displayNumber + change;
      }, 20);
    }
  }]);
  return NumberCountComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin));

NumberCountComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'NumberCountComponent',
  props: {
    number: {
      type: Number,
      default: 0
    },
    fontSize: {
      type: String,
      default: '3rem'
    },
    isShowThousand: {
      type: Boolean,
      default: true
    }
  }
})], NumberCountComponent);
var _default = NumberCountComponent;
exports.default = _default;